(function () {
  function fmsInit(root) {
    if (!root || root.dataset.fmsReady === '1') return;
    root.dataset.fmsReady = '1';

    var rail = root.querySelector('[data-fms-rail]');
    if (!rail) return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-fms-card]'));
    if (!cards.length) return;

    var prevBtn = root.querySelector('[data-fms-prev]');
    var nextBtn = root.querySelector('[data-fms-next]');
    var dotsWrap = root.querySelector('[data-fms-dots]');
    var lb = root.querySelector('[data-fms-lightbox]');
    var lbVideo = root.querySelector('[data-fms-lbvideo]');
    var lbCount = root.querySelector('[data-fms-lbcount]');
    var autoplayOn = root.dataset.autoplay === 'true';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = -1;
    var lastFocus = null;

    function videoOf(card) { return card.querySelector('.fms__video'); }

    function attach(card) {
      var v = videoOf(card);
      if (!v || v.dataset.fmsLoaded === '1') return v;
      v.src = card.dataset.src;
      v.dataset.fmsLoaded = '1';
      return v;
    }

    /* Lazily attach sources for cards that are on or near screen.
       Both halves matter: the observer can miss a fast scroll, so a
       throttled sweep backstops it. */
    function nearViewport(el, slack) {
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      return r.bottom > -slack && r.top < vh + slack;
    }

    function sweepAttach() {
      for (var i = 0; i < cards.length; i++) {
        if (nearViewport(cards[i], 600)) attach(cards[i]);
      }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting || entries[i].boundingClientRect.top < 0) {
            attach(entries[i].target);
          }
        }
      }, { rootMargin: '400px 600px' });
      cards.forEach(function (c) { io.observe(c); });
    }

    var sweepQueued = false;
    function queueSweep() {
      if (sweepQueued) return;
      sweepQueued = true;
      requestAnimationFrame(function () { sweepQueued = false; sweepAttach(); });
    }
    window.addEventListener('scroll', queueSweep, { passive: true });
    window.addEventListener('resize', queueSweep, { passive: true });
    sweepAttach();

    /* Only the card nearest the rail centre plays, so we never decode
       28 streams at once. */
    function centreIndex() {
      var box = rail.getBoundingClientRect();
      var mid = box.left + box.width / 2;
      var best = 0;
      var bestD = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var r = cards[i].getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - mid);
        if (d < bestD) { bestD = d; best = i; }
      }
      return best;
    }

    function stopAll(except) {
      for (var i = 0; i < cards.length; i++) {
        if (i === except) continue;
        var v = videoOf(cards[i]);
        if (v && !v.paused) v.pause();
        cards[i].classList.remove('is-playing');
      }
    }

    var railVisible = false;
    function syncPlayback() {
      var idx = centreIndex();
      stopAll(idx);
      if (!autoplayOn || reduce || !railVisible || !lb.hidden) return;
      var card = cards[idx];
      var v = attach(card);
      if (!v) return;
      var p = v.play();
      if (p && p.then) {
        p.then(function () { card.classList.add('is-playing'); })
         .catch(function () { card.classList.remove('is-playing'); });
      } else {
        card.classList.add('is-playing');
      }
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        railVisible = entries[0].isIntersecting;
        if (railVisible) syncPlayback(); else stopAll(-1);
      }, { threshold: 0.2 }).observe(rail);
    } else {
      railVisible = true;
    }

    var scrollTimer = null;
    rail.addEventListener('scroll', function () {
      updateDots();
      updateArrows();
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncPlayback, 140);
    }, { passive: true });

    function step() {
      var r = cards[0].getBoundingClientRect();
      var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || '0') || 0;
      return r.width + gap;
    }
    function page() {
      return Math.max(1, Math.floor(rail.clientWidth / step()));
    }
    function scrollByCards(dir) {
      rail.scrollBy({ left: dir * step() * page(), behavior: reduce ? 'auto' : 'smooth' });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCards(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCards(1); });

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prevBtn.disabled = rail.scrollLeft <= 2;
      nextBtn.disabled = rail.scrollLeft >= max;
    }

    var dots = [];
    if (dotsWrap) {
      dotsWrap.removeAttribute('aria-hidden');
      dotsWrap.setAttribute('role', 'tablist');
      dotsWrap.setAttribute('aria-label', 'Choose a clip');
      cards.forEach(function (card, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'fms__dot';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Clip ' + (i + 1));
        b.addEventListener('click', function () {
          rail.scrollTo({ left: card.offsetLeft - (rail.clientWidth - card.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
        });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }
    function updateDots() {
      if (!dots.length) return;
      var idx = centreIndex();
      for (var i = 0; i < dots.length; i++) {
        var on = i === idx;
        dots[i].classList.toggle('is-active', on);
        dots[i].setAttribute('aria-selected', on ? 'true' : 'false');
      }
    }

    /* Lightbox: sound on, full controls, never leaves the store. */
    function openAt(i) {
      current = ((i % cards.length) + cards.length) % cards.length;
      lastFocus = document.activeElement;
      stopAll(-1);
      lbVideo.src = cards[current].dataset.srcHd || cards[current].dataset.src;
      lbVideo.currentTime = 0;
      lbVideo.muted = false;
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if (lbCount) lbCount.textContent = (current + 1) + ' / ' + cards.length;
      var p = lbVideo.play();
      if (p && p.catch) p.catch(function () { /* browser blocked audio autoplay: controls are there */ });
      var closeBtn = lb.querySelector('[data-fms-close]');
      if (closeBtn && closeBtn.focus) closeBtn.focus();
    }
    function closeLb() {
      lb.hidden = true;
      lbVideo.pause();
      lbVideo.removeAttribute('src');
      lbVideo.load();
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      syncPlayback();
    }

    cards.forEach(function (card, i) {
      var btn = card.querySelector('[data-fms-open]');
      if (btn) btn.addEventListener('click', function () { openAt(i); });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-fms-close]'), function (el) {
      el.addEventListener('click', closeLb);
    });
    var lbPrev = root.querySelector('[data-fms-lbprev]');
    var lbNext = root.querySelector('[data-fms-lbnext]');
    if (lbPrev) lbPrev.addEventListener('click', function () { openAt(current - 1); });
    if (lbNext) lbNext.addEventListener('click', function () { openAt(current + 1); });

    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); closeLb(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); openAt(current + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); openAt(current - 1); }
      else if (e.key === 'Tab') {
        var f = lb.querySelectorAll('button, video');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    lbVideo.addEventListener('ended', function () { openAt(current + 1); });

    updateArrows();
    updateDots();
    setTimeout(syncPlayback, 300);
  }

  function fmsInitAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-fms]');
    for (var i = 0; i < nodes.length; i++) fmsInit(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { fmsInitAll(); });
  } else {
    fmsInitAll();
  }

  /* The theme editor re-renders a section into a fresh DOM node. */
  document.addEventListener('shopify:section:load', function (e) {
    fmsInitAll(e.target);
  });
})();
